import { useState, useEffect } from "react";

export default function useBurgerMenu() {
  const [hasBurgerMenu, setHasBurgerMenu] = useState(() => {
    return window.innerWidth <= 991;
  });

  useEffect(() => {
    const check = () => {
      setHasBurgerMenu(window.innerWidth <= 991);
    };

    check();
    window.addEventListener("resize", check);
    window.addEventListener("orientationchange", check);

    return () => {
      window.removeEventListener("resize", check);
      window.removeEventListener("orientationchange", check);
    };
  }, []);

  return hasBurgerMenu;
}